import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_summary_report, init_simulation } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import info from '../assets/info.png';
import General_feedback_active from "../assets/General_feedback_active.png";
import General_feedback_deactive from "../assets/General_feedback_deactive.png";
import Financial_analysis_active from "../assets/Finacial_analysis_active.png";
import Financial_analysis_deactive from "../assets/Financial_analysis_deactive.png";
import order_analysis_active from "../assets/order_analysis_active.png";
import order_analysis_deactive from "../assets/order_analysis_deactive.png";
import ExpenseBreakdownChart from "./ExpenseBreakdownChart";
import Button from '../../common/Button'
import OrderingAccuracyChart from "./OrderingAccuracyChart";
import RevenueGraph from "./RevenueGraph";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import prevArrow from "../assets/prevArrow.png";
import ImModuleStyle from '../styles/im.module.css';

const Summary = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
 
  const [summaryReports, setSummaryReports] = useState({});
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [attempt,setAttempt] = useState(queryParams.get("attempt"));
  const [pagination,setPagination] = useState({"prev":false,"next":false});
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();
  const [isActive, setIsActive] = useState("generalFeedback");
  const [executioninstanceid, setExecutioninstanceid]  = useState("");
  const [page, setPage] = useState(1);
  const [pageHeight, setPageHeight] = useState("");
  const summaryBtnStyle = {color: "white",borderRadius: "40px",margin: "0px",padding: "16px 55px",fontSize: "16px" };

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");
  const formatNum = (num) => {
    return num?.toLocaleString("en-US", { style: "decimal" });
  };
  const checkNum = (num) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
  };
  const handleSetActive = (e) => {
    const generalFeedbackOffset =
      document.getElementById(`${ImModuleStyle.generalFeedback}`).offsetTop - 20;
    const financialAnalysisOffset =
      document.getElementById(`${ImModuleStyle.financialAnalysis}`).offsetTop - 25;
    const orderAnalysisOffset =
      document.getElementById(`${ImModuleStyle.orderAnalysis}`).offsetTop - 25;

      if (e.type === "click") {
        if (e.currentTarget.classList.contains("generalFeedbackParent")) {
          //window.$(`div[id=${ImModuleStyle.generalFeedback}]`).find("h2").attr("tabindex","-1").focus();
          document.getElementById(`${ImModuleStyle.generalFeedback}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${ImModuleStyle.generalFeedback}`).querySelector("h2").focus();
          if(document.querySelector(`.${ImModuleStyle['summary-content-box']}`) != null){
            document.querySelector(`.${ImModuleStyle['summary-content-box']}`).scrollTop = generalFeedbackOffset - 20;
          }
        } else if (e.currentTarget.classList.contains("orderAnalysisParent")) {
          //window.$(`div[id=${ImModuleStyle.orderAnalysis}]`).find("h2").attr("tabindex","-1").focus();
          document.getElementById(`${ImModuleStyle.orderAnalysis}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${ImModuleStyle.orderAnalysis}`).querySelector("h2").focus();
          if(document.querySelector(`.${ImModuleStyle['summary-content-box']}`) != null){
            document.querySelector(`.${ImModuleStyle['summary-content-box']}`).scrollTop = orderAnalysisOffset - 10;
          }
        } else if (
          e.currentTarget.classList.contains("financialAnalysisParent")
        ) {
          //window.$(`div[id=${ImModuleStyle.financialAnalysis}]`).find("h2").attr("tabindex","-1").focus();
          document.getElementById(`${ImModuleStyle.financialAnalysis}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${ImModuleStyle.financialAnalysis}`).querySelector("h2").focus();
          if(document.querySelector(`.${ImModuleStyle['summary-content-box']}`) != null){
            document.querySelector(`.${ImModuleStyle['summary-content-box']}`).scrollTop = financialAnalysisOffset - 5;
          }
        }
      }
    const scrollPosition = e.currentTarget.scrollTop;

    if (
      scrollPosition >= generalFeedbackOffset &&
      scrollPosition < financialAnalysisOffset
    ) {
      document.querySelector(`.generalFeedbackParent `).blur();
      setIsActive("generalFeedback");
    } else if (
      scrollPosition >= financialAnalysisOffset &&
      scrollPosition < orderAnalysisOffset
    ) {
      document.querySelector(`.financialAnalysisParent `).blur();
      setIsActive("financialAnalysis");
    } else if (scrollPosition >= orderAnalysisOffset) 
    {
      document.querySelector(`.orderAnalysisParent `).blur();
      setIsActive("orderAnalysis");
    }
  };
  const navigateToSimulation = () => {
    navigate(rootRoute + "/im/simulation");
  };
  const handlePopupExitSim =(e) =>{
    window.close();
 }
  const initSummary = () => {
    (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/im/simulation`);
    window.$("html, body").animate({ scrollTop: 0, }, 100);
    window.$(".summary-content-box").animate({ scrollTop: 0, }, 100);
  };
  const backToSimulationList = () =>{
      setIsLoader(true);
      if(role == "student"){
         navigate(rootRoute + `/im/studentreview?${queryParams}`);
      }else{
        navigate(rootRoute + `/im/instructorreview?${queryParams}`);
      }
  }
  const getNextAttempt = () =>{  
    setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index + 1];
      if(currSdSObj != undefined){
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt",currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index + 2] != undefined) ? setPagination({"prev":true,"next":false}) : setPagination({"prev":false,"next":true});
      }else{
        setPagination({"prev":false,"next":true});
        setIsLoader(false);
      }
  }
  const getPrevAttempt = () =>{ 
    setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index - 1];
      if(currSdSObj != undefined){
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt",currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index - 2] != undefined) ? setPagination({"prev":false,"next":false}) : setPagination({"prev":true,"next":false});
      }else{
        setPagination({"prev":true,"next":false});
        setIsLoader(false);
      }
  }
  const OnLoadPagination = () =>{   
      let lastObjIndex = simulationDetailSummary?.length -1;
      let firstObjIndex = 0;
      let currentIndex = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      (currentIndex == lastObjIndex) && setPagination({"prev":false,"next":true});
      (currentIndex == firstObjIndex) && setPagination({"prev":true,"next":false});
      if((currentIndex != lastObjIndex) && (currentIndex != firstObjIndex)){
        setPagination({"prev":false,"next":false}); 
      }
  }
  const getSimulationDetailSummary = () => {  
    setSimulationDetailSummary((attempt != undefined && user_id != undefined) ? simObj?.simulationdetails : []);
    setIsLoader(false);
};
const updateExcutionInstanceId = () =>{  
  if(attempt != undefined && user_id != undefined){ 
    setExecutioninstanceid(simulationDetailSummary?.filter((sdObj)=>sdObj.attemptno == attempt)[0]?.executioninstanceid)
  }else{
    setExecutioninstanceid(simObj?.executioninstanceid)
  }
}
const getSummaryReport = () => {   
    ((simObj?.sessionid != undefined || session_id != undefined) && executioninstanceid != undefined && executioninstanceid.length > 0) && get_summary_report((simObj?.sessionid || session_id), executioninstanceid).then(
      (response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        setSummaryReports(response?.data);
        //console.log(response.data)
        OnLoadPagination();
        setIsLoader(false);
      }
      }).catch((error)=>{ 
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
    });
  };
  const generalClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".generalFeedbackParent").click();
      e.stopPropagation();
    }
    // else {
    //   document.querySelector("#generalFeedback").scrollIntoView({ behavior: 'smooth' })
    // }
    return 0;
  }
  const financialClickHandler = (e) => {
    if (window.innerWidth > 570) {
    e.preventDefault();
      document.querySelector(".financialAnalysisParent").click();
      e.stopPropagation();
    }
    // else {
    //   document.querySelector("#financialAnalysis").scrollIntoView({ behavior: 'smooth' })
    // }
    return 0;
  }
  const orderClickHandler = (e)=>{
    if (window.innerWidth > 570) {
    e.preventDefault();
      document.querySelector(".orderAnalysisParent").click();
      e.stopPropagation();
    }
    // else {
    //   document.querySelector("#orderAnalysis").scrollIntoView({ behavior: 'smooth' });
    // }
    return 0;
  }
  useEffect(()=>{
    setIsLoader(true);
    if (session_id != "" && simObj?.laststate == undefined) {//&& queryParams.get("sid") == undefined
      //setError(null);
      init_simulation(session_id).then(function (response) {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
      }
      else{
        // console.log(response.data);
        setSimObj(Object.assign(response?.data,{"simulationdetails":simObj?.simulationdetails}));
        setError(null);
      }
      }).catch((error)=>{
          // setError(errorMsg);
          setError({"id":"00000","msg":errorMsg})
      })
    }
  },[])
  useEffect(()=>{updateExcutionInstanceId();},[simulationDetailSummary])
  useEffect(()=>{ getSimulationDetailSummary();},[attempt])
  useEffect(()=>{ getSummaryReport();},[executioninstanceid])
  useEffect(() => {
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    if(document.querySelector(".App .row") != null){
      document.querySelector(".App .row").style.minHeight = "auto";
    }
    setIsLoader(true);
    initSummary(); 
    setAttempt(queryParams.get("attempt")) 
    const heading = document.querySelector(
      `.${ImModuleStyle['summary-container']} header.header h1`
    );

    if (heading) {
      heading.tabIndex = -1;
      heading.focus();
    }
    // document.querySelector(`.${ImModuleStyle['summary-container']} header.header h1`).tabIndex = -1;
    // document.querySelector(`.${ImModuleStyle['summary-container']} header.header h1`).focus();
    // const summaryPageHeight = window.innerHeight - document.querySelector(`.${ImModuleStyle['summary-container']} header.header`).clientHeight - document.getElementsByClassName(`${ImModuleStyle['summary-footer']}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight;
    // setPageHeight(summaryPageHeight - 1);

    const header = document.querySelector(
    `.${ImModuleStyle['summary-container']} header.header`
    );
    const summaryFooter = document.getElementsByClassName(
      ImModuleStyle['summary-footer']
    )[0];
    const footer = document.querySelector('.footer');

    if (header && summaryFooter && footer) {
      const summaryPageHeight =
        window.innerHeight -
        header.clientHeight -
        summaryFooter.clientHeight -
        footer.clientHeight;

      setPageHeight(summaryPageHeight - 1);
    }
    document.title = "Inventory Management | Summary";

    if(attempt != undefined && user_id != undefined){
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //     document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //     document.querySelector("footer.footer .container").style.justifyContent = "center";
      // }

      if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
          document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
      }
    }

    return () => {
      if(document.querySelector("header.header") != null){
        document.querySelector("header.header").style.display = "block";
      }
      if(document.querySelector(".App .row") != null){
        document.querySelector(".App .row").style.minHeight = "100vh";
      }
      if(attempt != undefined && user_id != undefined){
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
          document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
        }
        if (document.querySelector("footer.footer .container") != null) {
            document.querySelector("footer.footer .container").style.justifyContent = "space-between";
        }
      }
      
    };
  }, [simObj?.sessionid || session_id]);

  return (
    <motion.div className={`${ImModuleStyle['summary-container']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
      <header className={`header ${ImModuleStyle.header}`}>
        <div className={`container ${ImModuleStyle.container}`}>
          <div className={`${ImModuleStyle['icon-header-box']}`}>
            {
             (attempt != undefined && user_id != undefined) &&  <button onClick={backToSimulationList}><img src={prevArrow}/></button>
            }            
            <h1 className={`ui header title ${ImModuleStyle.ui} ${ImModuleStyle.header} ${ImModuleStyle.title}`}>  
              {attempt != undefined ? `Summary Report(Attempt ${attempt})` : "The year is over! Review your results below."}
            </h1>
          </div>
          {
            (attempt != undefined && user_id != undefined && simulationDetailSummary?.length != 1) && <div className={`${ImModuleStyle['pagination-icons']}`}>
              <button disabled={pagination.prev} onClick={getPrevAttempt}><img src={leftArrow} /></button>
              <button disabled={pagination.next} onClick={getNextAttempt}><img src={rightArrow} /></button>
            </div>
          }
        </div>
      </header>
      <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid} ${ImModuleStyle['summary-content']} `}>
        <div className={`column ${ImModuleStyle.column} ${ImModuleStyle['navigation-tab']}`}>
          <ul className={`ui link list ${ImModuleStyle.ui} ${ImModuleStyle.link} ${ImModuleStyle.list}`}>
            <li className={`item generalFeedbackParent ${ImModuleStyle['item']} ${isActive === "generalFeedback" ? `${ImModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("generalFeedback");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "generalFeedback" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${ImModuleStyle.generalFeedback}`} onClick={generalClickHandler} tabIndex={-1}> 
                <img src={isActive === "generalFeedback" ? General_feedback_active : General_feedback_deactive} alt="" />
                <span>GENERAL FEEDBACK</span>
              </a>
            </li>
            <li className={`item financialAnalysisParent ${ImModuleStyle['item']} ${isActive === "financialAnalysis" ? `${ImModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("financialAnalysis");
                // e.target.focus();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "financialAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${ImModuleStyle.financialAnalysis}`} onClick={financialClickHandler} tabIndex={-1}>
                <img src={isActive === "financialAnalysis" ? Financial_analysis_active : Financial_analysis_deactive} alt="" />
                <span>FINANCIAL ANALYSIS</span>
              </a>
            </li>
            <li className={`item orderAnalysisParent ${ImModuleStyle['item']} ${isActive === "orderAnalysis" ? `${ImModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("orderAnalysis");
                // e.target.focus();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "orderAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#${ImModuleStyle.orderAnalysis}`} onClick={orderClickHandler} tabIndex={-1}>
                <img src={isActive === "orderAnalysis" ? order_analysis_active : order_analysis_deactive} alt="" />
                <span>ORDER ANALYSIS</span>
              </a>
            </li>
          </ul>
        </div>
        <div className={`column summary-content-box ${ImModuleStyle.column} ${ImModuleStyle['summary-content-box']} `} onWheel={handleSetActive} style={{ height: pageHeight + "px" }} >
          <div className={`${ImModuleStyle.section}`} id={`${ImModuleStyle.generalFeedback}`} style={{ "marginTop": "0px" }}>
            <h2>General Feedback</h2>
            <table className={`ui unstackable table ${ImModuleStyle.ui} ${ImModuleStyle.unstackable} ${ImModuleStyle.table}`}>
              <thead>
                <tr>
                  <th id="paramtr" scope="col" className={`four wide ${ImModuleStyle.four} ${ImModuleStyle.wide}`}>Parameters</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <th id="prevSim" scope="col" className={`three wide right aligned ${ImModuleStyle.three} ${ImModuleStyle.wide} ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      Previous Simulation
                    </th>
                  ) : null }
                  <th id="currSim" scope="col" className={`three wide right aligned ${ImModuleStyle.three} ${ImModuleStyle.wide} ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    Current Simulation
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th id="pftOrdrng" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2} scope="row" className={`${ImModuleStyle['row-heading']}`}>
                    Profit and Ordering
                  </th>
                </tr>
                <tr className={`${ImModuleStyle['indent-row']}`}>
                  <th id="prft" headers="pftOrdrng" className={`eight wide ${ImModuleStyle.eight} ${ImModuleStyle.wide}`}>Profit (In $)</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <td headers="pftOrdrng prft prevSim" className={`four wide right aligned ${ImModuleStyle.four} ${ImModuleStyle.wide} ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      {
                        summaryReports?.GeneralFeedback?.last_GrossProfit && checkNum(summaryReports?.GeneralFeedback?.last_GrossProfit)
                      }
                    </td>
                  ) : null }
                  <td headers="pftOrdrng prft currSim"  className={`four wide right aligned ${ImModuleStyle.four} ${ImModuleStyle.wide} ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    {
                      summaryReports?.GeneralFeedback?.GrossProfit && checkNum(summaryReports?.GeneralFeedback?.GrossProfit)
                    }
                  </td>
                </tr>
                <tr>
                  <td headers="pftOrdrng prft" role="cell" className={`${ImModuleStyle['text-td']} ${ImModuleStyle['text-content']}`} colSpan={summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2}>
                      {summaryReports?.GeneralFeedback?.ProfitGoal}
                  </td>
                </tr>
                <tr className={`${ImModuleStyle['indent-row']}`}>
                  <th id="odrAcurcy" headers="pftOrdrng">Order Accuracy (based on EOQ)</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <td headers="pftOrdrng odrAcurcy premSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      {formatNum(summaryReports?.GeneralFeedback?.last_OrderAccuracyPercentage
                      )}
                    </td>
                  ) : null }
                  <td headers="pftOrdrng odrAcurcy currSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    {formatNum(summaryReports?.GeneralFeedback?.OrderAccuracyPercentage)}
                  </td>
                </tr>
                <tr>
                  <td headers="pftOrdrng odrAcurcy" role="cell" className={`${ImModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2}>
                   {summaryReports?.GeneralFeedback?.Orders}
                  </td>
                </tr>
                <tr>
                  <th id="invtry" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2} scope="row" className={`${ImModuleStyle['row-heading']}`}>
                    Inventory
                  </th>
                </tr>
                <tr className={`${ImModuleStyle['indent-row']}`}>
                  <th id="unsoldInvtry" headers="invtry">Unsold inventory due to stockouts</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <td headers="invtry unsoldInvtry prevSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      {formatNum(summaryReports?.GeneralFeedback?.last_StockOutUnits)}
                    </td>
                  ) : null }
                  <td headers="invtry unsoldInvtry currSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    {formatNum(summaryReports?.GeneralFeedback?.StockOutUnits)}
                  </td>
                </tr>
                <tr className={`${ImModuleStyle['indent-row']}`}>
                  <th id="totNoStkout" headers="invtry">Total number of stock out periods</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <td headers="invtry totNoStkout prevSim"  className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      {formatNum(summaryReports?.GeneralFeedback?.last_NumberOfTimesStockOut)}
                    </td>
                  ) : null }
                  <td headers="invtry totNoStkout currSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    {formatNum(summaryReports?.GeneralFeedback?.NumberOfTimesStockOut)}
                  </td>
                </tr>
                <tr>
                  <td headers="invtry totNoStkout" className={`${ImModuleStyle['text-td']} ${ImModuleStyle['text-content']}`} colSpan={summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2}>
                      {summaryReports?.GeneralFeedback?.StockOut}
                  </td>
                </tr>
                <tr className={`${ImModuleStyle['indent-row']}`}>
                  <th id="daysWtoutInvtry" headers="invtry">Number of days without inventory</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <td headers="invtry daysWtoutInvtry prevSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      {formatNum(summaryReports?.GeneralFeedback?.last_StockOutDurationInDays)}
                    </td>
                  ) : null }
                  <td headers="invtry daysWtoutInvtry currSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    {formatNum(summaryReports?.GeneralFeedback?.StockOutDurationInDays)}
                  </td>
                </tr>
                <tr>
                  <td headers="invtry daysWtoutInvtry" className={`${ImModuleStyle['text-td']} ${ImModuleStyle['text-content']}`} colSpan={summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2}>
                      {summaryReports?.GeneralFeedback?.StockOutDuration}
                  </td>
                </tr>
                <tr className={`${ImModuleStyle['indent-row']}`}>
                  <th id="excInvtry" headers="invtry">Excess inventory (end of the year)</th>
                  {summaryReports?.GeneralFeedback?.last_GrossProfit != "NA" ? (
                    <td headers="invtry excInvtry prevSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                      {formatNum(summaryReports?.GeneralFeedback?.last_ExcessInventoryEOY)}
                    </td>
                  ) : null }
                  <td  headers="invtry excInvtry currSim" className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                    {formatNum(summaryReports?.GeneralFeedback?.ExcessInventoryEOY)}
                  </td>
                </tr>
                <tr>
                  <td headers="invtry excInvtry" className={`${ImModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2}>
                    {summaryReports?.GeneralFeedback?.ExcessInventory}
                  </td>
                </tr>
                <tr>
                  <th id="msgNotfn" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2} scope="row" className={`${ImModuleStyle['row-heading']}`}>
                   Messages and Notifications
                  </th>
                </tr>
                <tr>
                  <td headers="msgNotfn" className={`${ImModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_GrossProfit !== "NA" ? 3 : 2}>
                      {summaryReports?.GeneralFeedback?.ReadArtifact}
                      {summaryReports?.GeneralFeedback?.RemaingArtifactVedict}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={`${ImModuleStyle.section} ${ImModuleStyle['financial-analysis-div']}`} id={`${ImModuleStyle.financialAnalysis}`}>
            <h2 className={`ui header ${ImModuleStyle.ui} ${ImModuleStyle.header}`}>Financial Analysis</h2>
            <p>{summaryReports?.FinancialSummary?.ProfitGoal}</p>
            <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
              <div className={`column ${ImModuleStyle.column} ${ImModuleStyle['table-block']}`}>
                <table className={`ui unstackable table ${ImModuleStyle.ui} ${ImModuleStyle.unstackable} ${ImModuleStyle.table}`}>
                  <tbody>
                    <tr>
                      <td>Units Demanded </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {formatNum(summaryReports?.FinancialSummary?.GrossDemand)}
                      </td>
                    </tr>
                    <tr>
                      <td>- Units Unsold Due to Stockouts </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {formatNum(summaryReports?.FinancialSummary?.StockOutUnits)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Units Sold</strong>
                      </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        <strong>
                          {formatNum(summaryReports?.FinancialSummary?.GrossUnitsSold)}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation" />
                      </td>
                    </tr>
                    <tr>
                      <td>Units Sold</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {formatNum(summaryReports?.FinancialSummary?.GrossUnitsSold)}
                      </td>
                    </tr>
                    <tr>
                      <td>x Price</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.UnitSellingPrice)}
                      </td>
                    </tr>
                    <tr>
                      <td>+ Liquidated Units</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {formatNum(summaryReports?.FinancialSummary?.LiquidatedInventory)}
                      </td>
                    </tr>
                    <tr>
                      <td>x Price</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.CostPerUnit)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Revenue</strong>
                      </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        <strong>
                          {checkNum(summaryReports?.FinancialSummary?.GrossRevenue)}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation" />
                      </td>
                    </tr>
                    <tr>
                      <td>Product Cost</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.GrossPurchaseCost)}
                      </td>
                    </tr>
                    <tr>
                      <td>+ Holding Cost</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.GrossHoldingCost)}
                      </td>
                    </tr>
                    <tr>
                      <td>+ Ordering Cost</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.GrossOrderingCost)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Cost</strong>
                      </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        <strong>
                          {checkNum(summaryReports?.FinancialSummary?.GrossCost)}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation" />
                      </td>
                    </tr>
                    <tr>
                      <td>Total Revenue</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.GrossRevenue)}
                      </td>
                    </tr>
                    <tr>
                      <td>- Total Cost</td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        {checkNum(summaryReports?.FinancialSummary?.GrossCost)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Profit</strong>
                      </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        <strong>
                          {checkNum(summaryReports?.FinancialSummary?.GrossProfit)}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Profit Percentage</strong>
                      </td>
                      <td className={`right aligned ${ImModuleStyle.right} ${ImModuleStyle.aligned}`}>
                        <strong>
                          {summaryReports?.FinancialSummary?.ProfitPercentage}%
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className={`column ${ImModuleStyle.column} ${ImModuleStyle['expense-graph-block']}`}>
                <ExpenseBreakdownChart summaryReports={summaryReports} ></ExpenseBreakdownChart>
                <div className={`${ImModuleStyle['EBreakdown-legends']}`}>
                  <div className={`${ImModuleStyle['EB-OrderingCost']}`}><span className={`${ImModuleStyle['EBreakdownpattern']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['OrderingCo-legend-sign1']}`}></div></span>Ordering Cost</div>
                  <div className={`${ImModuleStyle['EB-HoldingCost']}`}><span className={`${ImModuleStyle['EBreakdownpattern']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['HoldingCo-legend-sign2']}`}></div></span>Holding Cost</div>
                  <div className={`${ImModuleStyle['EB-ProductCost']}`}><span className={`${ImModuleStyle['EBreakdownpattern']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['ProductCo-legend-sign3']}`}></div></span>Product Cost</div>
                </div>
                <div className={`${ImModuleStyle['Revenue-cost-legends']} ${ImModuleStyle['Revenue-cost-summary']}`}>
                <div className={`${ImModuleStyle['container-div']}`} aria-hidden="true">
                  <div className={`${ImModuleStyle['circle-line']}`}></div>
                  <div className={`${ImModuleStyle['horizontal-line-circle']}`}></div>  
                </div>
                  <div>Revenue</div>
                <div className ={`${ImModuleStyle['container-div']}`} aria-hidden="true">
                    <div className ={`${ImModuleStyle['horizontal-line-rhombus']}`}></div>
                    <div className ={`${ImModuleStyle['rhombus']}`}></div>
                    <div className ={`${ImModuleStyle['circle-rhombus']}`}></div>
                </div>
                <div>Costs</div>
                </div>
                <RevenueGraph type={"yearly"} simObj={simObj} isResult={true} summaryGraphData={summaryReports?.FinancialSummary?.graphdata} setSimObj={setSimObj} attempt={attempt}></RevenueGraph>
              </div>
            </div>
          </div>
          <div className={`${ImModuleStyle.section} ${ImModuleStyle['order-analysis-div']}`} id={`${ImModuleStyle.orderAnalysis}`}>
            <h2 className={`ui header ${ImModuleStyle.ui} ${ImModuleStyle.header}`}>Order Analysis</h2>
            <p>
              Review the breakdown of your orders and think about how you could
              improve your profits through ordering decisions.
            </p>
            <div className={`ui stackable two column grid ${ImModuleStyle.ui} ${ImModuleStyle.stackable} ${ImModuleStyle.column} ${ImModuleStyle.grid}`}>
              <div className={`column ${ImModuleStyle.column} ${ImModuleStyle['inventory-block']}`}>
                <h3 className={`${ImModuleStyle['order-headers']}`}>Inventory level</h3>
                <div className={`${ImModuleStyle['order-accuracy-container']}`}>
                  <div className={`${ImModuleStyle['icon-text-div']}`}>
                    <div className={`${ImModuleStyle['order-accuracy-graph']}`} inventory-level={summaryReports?.OrderAnalysis?.InventoryLevel}>
                    </div>
                    <div className={`${ImModuleStyle['inventory-level-text']}`}>
                      <h3>Inventory Level</h3>
                      <div>{summaryReports?.OrderAnalysis?.InventoryLevel}</div>
                    </div>
                  </div>
                </div>
                <div className={`${ImModuleStyle['inventory-ordering-container']}`}>
                  <p className={`${ImModuleStyle.content}`}>
                    {summaryReports?.OrderAnalysis?.InventoryLevelVerdict}
                  </p>
                  <div className={`${ImModuleStyle['calculation-block']}`}>
                    <h4>Calculations:</h4>
                    <p className="formula-text-div">
                      <strong>High Inventory: </strong> Inventory value when
                      order is placed is greater than {">"}= 1.2* EOQ
                    </p>
                    <p>
                      <strong>Low Inventory: </strong>Inventory value when order
                      is placed is less than {"<"}= D* (T+3)
                    </p>
                    <p>
                      <strong>Normal Inventory: </strong>Inventory value when
                      order is placed is Anything in between high and low
                    </p>
                  </div>
                </div>
              </div>
              <div className={`column ${ImModuleStyle.column} ${ImModuleStyle['ordering-block']}`}>
                <h3 className={`${ImModuleStyle['order-headers']}`}>Ordering Accuracy</h3>
                <OrderingAccuracyChart summaryReports={summaryReports} ></OrderingAccuracyChart>
                <div className={`${ImModuleStyle['OrderingAccuracy-legends']}`}>
                  <div className={`${ImModuleStyle['NoOrder']}`}><span className={`${ImModuleStyle['OrderingAccuracyPatterns']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['NoOrder-legend-sign1']}`}></div></span>No Order</div>
                  <div className={`${ImModuleStyle['OnTarget']}`}><span className={`${ImModuleStyle['OrderingAccuracyPatterns']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['OnTarget-legend-sign2']}`}></div></span>On Target</div>
                  <div className={`${ImModuleStyle['High']}`}><span className={`${ImModuleStyle['OrderingAccuracyPatterns']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['High-legend-sign3']}`}></div></span>High</div>
                  <div className={`${ImModuleStyle['Low']}`}><span className={`${ImModuleStyle['OrderingAccuracyPatterns']}`} aria-hidden="true" role="presentation"><div className={`${ImModuleStyle['Low-legend-sign4']}`}></div></span>Low</div>
                </div>
                <div className={`${ImModuleStyle['inventory-ordering-container']}`}>
                  <p className={`${ImModuleStyle.content}`}>
                    {summaryReports?.OrderAnalysis?.OderingAccuracyVerdict}
                  </p>
                  <div className={`${ImModuleStyle['calculation-block']}`}>
                    <h4>Calculations:</h4>
                    <p className="formula-text-div">
                      <strong>High Order: </strong> Ordered Quantity is {">"}=
                      1.25* EOQ
                    </p>
                    <p>
                      <strong>On Target Order: </strong>Ordered Quantity is
                      anything in between High order value and Low Order value
                    </p>
                    <p>
                      <strong>Low Order: </strong>Ordered Quantity is {"<"}=
                      0.75* EOQ
                    </p>
                    <p>
                      <strong>EOQ: </strong>
                      <span className={`${ImModuleStyle.squereRoot}`}></span>(2* Normal Shipping
                      Cost * Daily Demand)/ Unit Holding Cost
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`${ImModuleStyle['summary-footer']}`}>
        {
          !(attempt != undefined && user_id != undefined) && <div className={`${ImModuleStyle['summary-btn-container']}`}>
              <Button btnName="BACK TO SIMULATION" btnId="backToSimulationBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={navigateToSimulation} />
              {
                summaryReports.nextattempt ? (<Button btnName="START OVER" btnId="startOverBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={startOverSimulation} />) 
                : (<span style={{'display':'flex'}}><img src={info} alt="info" /><em>You do not have any remaining attempts.</em></span>)
              }              
              <Button btnName="DONE" btnId="doneBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={handlePopupExitSim} />
            </div>          
        }      
        </div>  
      </div>
    </motion.div>
  );
};

export default Summary;
